module.exports = __webpack_public_path__ + "img/diners club.abc4a95e.svg";